import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/app/src/layout.tsx";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Content = makeShortcode("Content");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Content mdxType="Content">
      <p>{`Inspiring workshops, thought-provoking conferences, or unforgettable teambuilding events. Step away from conventional spaces and organize an event for your colleagues, partners, or friends surrounded by nature.`}</p>
      <p><strong parentName="p">{`For your corporate event, Hotel Studničky offers:`}</strong></p>
      <ul>
        <li parentName="ul">{`A restaurant with a capacity of 100 guests`}</li>
        <li parentName="ul">{`A conference room`}</li>
      </ul>
      <p>{`Our conference room provides ample privacy. It is located on a separate floor, making it isolated from the accommodation area. It also includes a kitchenette, where we are happy to prepare small snacks and coffee to recharge your energy. The conference room is fully equipped, with a data projector and flipchart available. You can also step directly out onto a spacious terrace and enjoy beautiful views of the surrounding nature during breaks.`}</p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1200px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.333333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAMABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQBAgP/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABTlVqKwLCf//EABkQAAMBAQEAAAAAAAAAAAAAAAECAwAREv/aAAgBAQABBQL0MW3ScHbkZhq3QJT/xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAwEBPwGn/8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8Bh//EABsQAAMAAgMAAAAAAAAAAAAAAAABERAxEiFR/9oACAEBAAY/At42cb14NVkVP//EABsQAAMAAgMAAAAAAAAAAAAAAAABESFhMUHB/9oACAEBAAE/Icsh+ELyUPYcyE+IGJQkuiq42f/aAAwDAQACAAMAAAAQrx//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAwEBPxAr/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAECAQE/EKZH/8QAHBABAAMBAAMBAAAAAAAAAAAAAQARITFBUWHB/9oACAEBAAE/EAq0YqOYI44Hj5kuZQKHOQgS1uDETA1guh6+x8lW9W9T8n//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/25cc381756edeade8f798a7227df6ed2/e93cc/69811029_1160057287525484_983508181768470528_o.webp 300w", "/static/25cc381756edeade8f798a7227df6ed2/b0544/69811029_1160057287525484_983508181768470528_o.webp 600w", "/static/25cc381756edeade8f798a7227df6ed2/68fc1/69811029_1160057287525484_983508181768470528_o.webp 1200w", "/static/25cc381756edeade8f798a7227df6ed2/a2303/69811029_1160057287525484_983508181768470528_o.webp 1800w", "/static/25cc381756edeade8f798a7227df6ed2/7c4f2/69811029_1160057287525484_983508181768470528_o.webp 2048w"],
              "sizes": "(max-width: 1200px) 100vw, 1200px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/25cc381756edeade8f798a7227df6ed2/73b64/69811029_1160057287525484_983508181768470528_o.jpg 300w", "/static/25cc381756edeade8f798a7227df6ed2/3ad8d/69811029_1160057287525484_983508181768470528_o.jpg 600w", "/static/25cc381756edeade8f798a7227df6ed2/6c738/69811029_1160057287525484_983508181768470528_o.jpg 1200w", "/static/25cc381756edeade8f798a7227df6ed2/8b34c/69811029_1160057287525484_983508181768470528_o.jpg 1800w", "/static/25cc381756edeade8f798a7227df6ed2/8fe94/69811029_1160057287525484_983508181768470528_o.jpg 2048w"],
              "sizes": "(max-width: 1200px) 100vw, 1200px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/25cc381756edeade8f798a7227df6ed2/6c738/69811029_1160057287525484_983508181768470528_o.jpg",
              "alt": "69811029 1160057287525484 983508181768470528 o",
              "title": "69811029 1160057287525484 983508181768470528 o",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1200px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAgP/xAAWAQEBAQAAAAAAAAAAAAAAAAACAAH/2gAMAwEAAhADEAAAAZvR1kKUbLf/xAAaEAACAwEBAAAAAAAAAAAAAAAAAgEDBBES/9oACAEBAAEFAoY7JPWM1C2pONCyrw//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAwEBPwFX/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGxAAAgEFAAAAAAAAAAAAAAAAAAESAhARITH/2gAIAQEABj8CtwlUabRiR//EABoQAQADAAMAAAAAAAAAAAAAAAEAEYEhMVH/2gAIAQEAAT8hG8gzcsWKNrfKIl7rYyc+T//aAAwDAQACAAMAAAAQ9w//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAWEQEBAQAAAAAAAAAAAAAAAAAAEQH/2gAIAQIBAT8QuI//xAAdEAEAAwACAwEAAAAAAAAAAAABABEhUcExYYGx/9oACAEBAAE/EDZ0oVdUy2ho3m/WS9eDMK/YEaDGX25wySr2h5QDzjuf/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/65c08549e2523ba99517e3e6cd95fdb3/e93cc/70851301_1160057174192162_395144112287776768_o.webp 300w", "/static/65c08549e2523ba99517e3e6cd95fdb3/b0544/70851301_1160057174192162_395144112287776768_o.webp 600w", "/static/65c08549e2523ba99517e3e6cd95fdb3/68fc1/70851301_1160057174192162_395144112287776768_o.webp 1200w", "/static/65c08549e2523ba99517e3e6cd95fdb3/a2303/70851301_1160057174192162_395144112287776768_o.webp 1800w", "/static/65c08549e2523ba99517e3e6cd95fdb3/7c4f2/70851301_1160057174192162_395144112287776768_o.webp 2048w"],
              "sizes": "(max-width: 1200px) 100vw, 1200px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/65c08549e2523ba99517e3e6cd95fdb3/73b64/70851301_1160057174192162_395144112287776768_o.jpg 300w", "/static/65c08549e2523ba99517e3e6cd95fdb3/3ad8d/70851301_1160057174192162_395144112287776768_o.jpg 600w", "/static/65c08549e2523ba99517e3e6cd95fdb3/6c738/70851301_1160057174192162_395144112287776768_o.jpg 1200w", "/static/65c08549e2523ba99517e3e6cd95fdb3/8b34c/70851301_1160057174192162_395144112287776768_o.jpg 1800w", "/static/65c08549e2523ba99517e3e6cd95fdb3/8fe94/70851301_1160057174192162_395144112287776768_o.jpg 2048w"],
              "sizes": "(max-width: 1200px) 100vw, 1200px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/65c08549e2523ba99517e3e6cd95fdb3/6c738/70851301_1160057174192162_395144112287776768_o.jpg",
              "alt": "70851301 1160057174192162 395144112287776768 o",
              "title": "70851301 1160057174192162 395144112287776768 o",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
      <p><strong parentName="p">{`Choose Studničky for your special event:`}</strong></p>
      <ul>
        <li parentName="ul">{`Accommodation for up to 40 guests`}</li>
        <li parentName="ul">{`Excellent homemade cuisine`}</li>
        <li parentName="ul">{`Intimate atmosphere and complete privacy in the embrace of nature`}</li>
        <li parentName="ul">{`Great location right next to the ski slope`}</li>
        <li parentName="ul">{`4 ski lifts for beginners and advanced skiers (total slope length: 1400 m)`}</li>
        <li parentName="ul">{`Technically snow-covered and daily groomed slopes`}</li>
        <li parentName="ul">{`Full-day skipass included in the package price`}</li>
        <li parentName="ul">{`Ski equipment storage directly in the hotel – private ski room`}</li>
        <li parentName="ul">{`Full ski equipment rental and ski service (for an additional fee)`}</li>
        <li parentName="ul">{`A variety of year-round activities`}</li>
        <li parentName="ul">{`Parking at the hotel`}</li>
      </ul>
      <p>{`If you're interested in hosting an event at our hotel, don’t hesitate to `}<a parentName="p" {...{
          "href": "/en/contact-us/"
        }}>{`contact us`}</a>{`.`}</p>
    </Content>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      